/**
 * API Configuration
 */
import axios from 'axios';
import { clearAuthAndReload, refreshAccessToken } from './authRefresh';

export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://labs.xmacna.ai/strategy-api'
  : 'http://localhost:3003/api';

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('xmacna_auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error.config;
    if (error.response?.status === 401 && request && !request._retry) {
      request._retry = true;
      try {
        const token = await refreshAccessToken(API_URL);
        request.headers.Authorization = `Bearer ${token}`;
        return apiClient(request);
      } catch {
        clearAuthAndReload();
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
